<script setup lang="ts">
import { computed } from 'vue'
import { ToastContainer } from '@ai/ui-components'
import { useToastViewportStore } from '@/composables/toast'

const { currentPreset } = useToastViewportStore()

const TOAST_VIEWPORT_BASE_CONTAINER_CLASSES =
  'w-[330px] transition-transform duration-300 ease-in-out will-change-transform z-[99999]!'

const TOAST_VIEWPORT_PRESET_CLASSES = {
  default: 'translate-x-0 translate-y-0',
  'right-panel': 'translate-x-1 -translate-y-1',
  'right-panel-floating': '-translate-x-4 translate-y-4',
} as const

const containerClass = computed(() => [
  TOAST_VIEWPORT_BASE_CONTAINER_CLASSES,
  TOAST_VIEWPORT_PRESET_CLASSES[currentPreset.value],
])
</script>

<template>
  <ToastContainer data-testid="app-toast-container" :class="containerClass" />
</template>
